import React, { useEffect } from "react";
import TokenService from "../Base/Services/TokenService";
import UserService from "../Base/Services/UserService";

export const AdoptionUserStorageKey = "currentAdoptionUser";

export const AuthContext = React.createContext();

export default function AuthContextProvider({ children }) {
  const [userInfo, setUserInfoState] = React.useState({});
  const isLoggedIn = React.useMemo(() => Boolean(userInfo.userId), [userInfo]);
  const isAdministrator = React.useMemo(() => Boolean(userInfo?.administrator), [userInfo]);
  const [initialized, setInitialized] = React.useState(false);
  useEffect(() => {
    // When the app loads, attempt to load the authenticated user
    UserService.getAuthenticatedUser()
      .then((authUser) => {
        if (authUser) {
          setUserInfo(authUser);
        } else {
          // Logout of the application if no user found, just to be safe
          logout();
        }
      })
      .catch(logout)
      .finally(() => setInitialized(true));
  }, []);

  function navigateToUtahIDLogin() {
    // Remove the stored token before logging in and getting a new one
    TokenService.clearStoredTokens();
    const utahIdUrl =
      "https://login.dts.utah.gov:443/sso/oauth2/authorize" +
      `?client_id=${process.env.REACT_APP_AUTH_CLIENT_ID}` +
      `&redirect_uri=${TokenService.getAuthRedirectUri()}` +
      "&scope=openid profile email directory phone app:dohAdoption offline_access" +
      "&response_type=code" +
      `&state=${TokenService.generateStateForAuth()}`;
    window.location = utahIdUrl;
  }

  function logout() {
    localStorage.removeItem(AdoptionUserStorageKey);
    TokenService.clearStoredTokens();
    setUserInfoState({});
  }

  function setUserInfo(user) {
    setUserInfoState(user);
  }

  return (
    <AuthContext.Provider
      value={{
        navigateToUtahIDLogin,
        logout,
        isLoggedIn,
        isAdministrator,
        userInfo,
        setUserInfo,
        initialized,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
